import { overview } from "@/service/finance";
import { runningCluster } from "@/service/k8sContainer";
import { logout, refreshToken as refreshTokenApi } from "@/service/login";
import { getAccessKey } from "@/service/objectStorage";
import { getUserInfo as fetchUserInfoApi } from "@/service/user";
import { getAccountInfo, getRefreshToken, getRoles, getToken, getUserInfo, removeAccountInfo, setAccountInfo, setRefreshToken, setRoles, setToken, setUserInfo } from "@/utils/auth";
import { defineStore } from "pinia";
const clearUserInfo = [
    "userInfo",
    "RefreshToken",
    "Roles",
    "loginState",
    "Token",
    "accountInfo",
    "cluster"
];
export const useCounterStore = defineStore("user", {
    state: () => ({
        userInfo: getUserInfo(),
        token: getToken(),
        refreshTokenValue: getRefreshToken(),
        roles: getRoles() || [],
        accountInfo: getAccountInfo() || {},
        files: [],
        accessKeyInfo: {},
        balance: 0,
        cashBalance: 0
    }),
    getters: {
        getFiles: (state) => state.files,
        getAccessKeyInfo: (state) => state.accessKeyInfo,
        getRoles: (state) => state.roles,
        getStoreToken: (state) => state.token,
        getUserInfo: (state) => state.userInfo,
        getRefreshToken: (state) => state.refreshTokenValue,
        getAccountInfo: (state) => state.accountInfo,
        getBalance: (state) => state.balance,
        getCashBalance: (state) => state.cashBalance
    },
    actions: {
        fetchUserInfo() {
            return new Promise(async () => {
                const res = await fetchUserInfoApi();
                this.setValue({
                    ...this.userInfo,
                    extra: {
                        authentication_type: res.data.extra.authentication_type,
                        edu_auth_status: res.data.extra.edu_auth_status,
                        edu_auth_enabled: res.data.extra.edu_auth_enabled,
                        edu_auth_expired_at: res.data.extra.edu_auth_expired_at,
                        contact_name: res.data.extra.contact_name,
                        contact_id_card: res.data.extra.contact_id_card
                    },
                    alliance_type: res.data.alliance_type,
                    is_recharged: res.data.is_recharged,
                    init_realname_cert_over_30_days: res.data.extra.init_realname_cert_over_30_days,
                    CloseGuide: res.data.CloseGuide
                });
            });
        },
        fetchBalance() {
            if (this.userInfo?.type === "sub")
                return;
            return new Promise((resolve) => {
                overview().then((res) => {
                    this.cashBalance = res.data.balance.balance;
                    this.balance = res.data.balance.total;
                    resolve(res.data.balance.balance);
                });
            });
        },
        setFileList(data) {
            return new Promise((resolve) => {
                this.files = this.files.concat(data);
                resolve(this.files);
            });
        },
        removeFiles(index) {
            return new Promise((resolve) => {
                this.files.splice(index, 1);
                resolve(this.files);
            });
        },
        searchRunningCluster(clusterId) {
            return new Promise((resolve, reject) => {
                runningCluster({ cluster_id: clusterId })
                    .then((res) => {
                    if (!res.data.is_cluster_running) {
                        localStorage.removeItem(getUserInfo().user_id);
                    }
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        logout() {
            return new Promise((resolve, reject) => {
                logout()
                    .then((res) => {
                    resolve(res);
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        getAccessInfo(params) {
            return new Promise((resolve, reject) => {
                getAccessKey(params)
                    .then((res) => {
                    this.accessKeyInfo = {
                        endpoint: `https://${res.data.eos_endpoint}`,
                        forcePathStyle: true,
                        region: res.data.s3_region,
                        credentials: {
                            accessKeyId: res.data.access_key_id,
                            secretAccessKey: res.data.access_key_secret,
                            endpoint: res.data.eos_endpoint
                        }
                    };
                    resolve(this.accessKeyInfo);
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        refreshToken() {
            return new Promise((resolve, reject) => {
                const params = {
                    refresh_token: this.refreshTokenValue || ""
                };
                refreshTokenApi(params)
                    .then((res) => {
                    this.token = res.data.access_token;
                    this.refreshTokenValue = res.data.refresh_token;
                    this.userInfo.access_token = res.data.access_token;
                    setToken(this.token || "");
                    setUserInfo(this.userInfo);
                    setRefreshToken(this.refreshTokenValue || "");
                    resolve("");
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        resetToken() {
            return new Promise((resolve) => {
                this.token = "";
                this.roles = [];
                for (const key of clearUserInfo) {
                    localStorage.removeItem(key);
                }
                sessionStorage.clear();
                resolve("");
            });
        },
        setValue(value) {
            this.$patch({
                token: value.access_token || "",
                refreshTokenValue: value.refresh_token,
                userInfo: value,
                roles: [value.type]
            });
            setRoles(this.roles);
            setToken(this.token || "");
            setUserInfo(value);
            setRefreshToken(value.refresh_token);
        },
        storeSetAccountInfo(value) {
            this.accountInfo = value;
            setAccountInfo(value);
        },
        storeRemoveAccountInfo() {
            this.accountInfo = {};
            removeAccountInfo();
        }
    }
});
